export default __webpack_public_path__ + "static/media/Mockup_Report-HealthyRelationship.0eb2ad00.jpg";